import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './app/App'
import { BRAND } from './brand/brand'
import './design-system/styles/global.css'

document.documentElement.dataset['brand'] = BRAND.id

const container = document.getElementById('root')
if (!container) throw new Error('Root element #root not found')

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
